import { getReadableRJSFErrors } from '@/components/forms/components/form/rjsf.utils';

type Props = {
  cellErrorMessages: string[];
  columnKey?: string;
};

export const TableCellError = (props: Props) => {
  const prettyError = props.cellErrorMessages.map(message =>
    getReadableRJSFErrors({
      message,
      propertyName: props.columnKey,
      itemName: 'cell'
    })
  );

  return (
    <div className="max-w-xs">
      {prettyError.map((message, i) => (
        <div className="mb-1 flex items-start text-xs" key={i}>
          <div className="inline-flex gap-2">
            ⚠️ <p className="first-letter:uppercase">This cell{message}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
